export default __webpack_public_path__ + "static/desktop-chart-01-m-0320612a279de93dfb1710fc25a72e84.svg";